import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-nutrition-quality',
    templateUrl: './nutrition-quality.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./nutrition-quality.component.scss']
})
export class NutritionQualityComponent implements OnInit {

    nutritionTabIndex = 0;

    nutritionEntries: string [] = ["fat", "carbs", "protein", "salt"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public nutritionId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    private initActiveTab() {
        const tabIndex = this.nutritionEntries.indexOf(this.nutritionId, 0)
        this.nutritionTabIndex = tabIndex
    }

}
